import {
  GET_OUT_RIGHT_SAVED_COUPONS_REQUEST,
  GET_OUT_RIGHT_SAVED_COUPONS_SUCCESS,
  GET_OUT_RIGHT_SAVED_COUPONS_FAILURE,
  RESET_OUT_RIGHT_SAVED_PAGINATION
} from 'Store/constants';

const initialState = {
  data: [],
  pagination: {
    pageSize: 10,
    pageIndex: 0,
    isLoadMoreButtonVisible: false
  },
  isFetched: false,
  isLoading: null,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    
    case GET_OUT_RIGHT_SAVED_COUPONS_REQUEST:
      return { ...state, isLoading: true, error: null };
    
    case GET_OUT_RIGHT_SAVED_COUPONS_SUCCESS:
      return {
        data: [...state.data, ...action.payload],
        pagination: action.pagination,
        isFetched: true,
        isLoading: false,
        error: null
      };
    
    case GET_OUT_RIGHT_SAVED_COUPONS_FAILURE:
    
      if (action.payload.code === 1009) {
        return {
          ...state,
          pagination: {
            ...initialState.pagination,
            isLoadMoreButtonVisible: false
          },
          isFetched: true,
          isLoading: false,
          error: action.payload };
      }

      return {
        ...state,
        pagination: initialState.pagination,
        isFetched: true,
        isLoading: false,
        error: action.payload };
    
    case RESET_OUT_RIGHT_SAVED_PAGINATION:
      return {
        ...state,
        pagination: initialState.pagination,
        data: []
      };
    
    default:
      return state;
  }
};
